import { DirectiveBinding } from 'vue'

/**
 * @description: 用于2.5.0以下版本<el-select>组件，指定已选tags关闭图标的隐藏
 */
export default {
  updated(el: any, binding: DirectiveBinding) {
    const dealData: string[] = binding.value
    let timer: NodeJS.Timeout | null = null

    timer = setTimeout(() => {
      const elArr: HTMLElement[] = el.querySelectorAll('.el-tag__content .el-select__tags-text')
      elArr?.forEach(item => {
        if (dealData?.includes(item.innerText)) {
          const nextSibling = item.parentNode?.nextSibling as HTMLElement
          if (nextSibling) {
            nextSibling.style.setProperty('display', 'none')
          }
        }
      })
      timer && clearTimeout(timer)
    })
  }
}
